export default "__VITE_ASSET__BIsNYMqE__"